import { styled } from "@mui/material/styles";
import { Box, BoxProps, InputAdornment, Select, SelectProps, Switch, SwitchProps, Typography } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import { ReactComponent as JobSearch } from "../../../../assets/job-search.svg";

export const IOSSwitch = styled((props: SwitchProps) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
    ({ theme }) => ({
        width: 40,
        height: 22,
        padding: 0,
        marginLeft: 16,
        "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 0,
            transitionDuration: "300ms",
            "&.Mui-checked": {
                transform: "translateX(18px)",
                color: "#fff",
                "& + .MuiSwitch-track": {
                    backgroundColor: "#65C466",
                    opacity: 1,
                    border: 0,
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: 0.5,
                },
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
                color: "#33cf4d",
                border: "6px solid #fff",
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
                color: "grey[100]",
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.7,
            },
        },
        "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 22,
            height: 22,
        },
        "& .MuiSwitch-track": {
            borderRadius: 26 / 2,
            backgroundColor: "grey",
            opacity: 1,
        },
    })
);

export const BoxFilter = styled((props: BoxProps & { opensidebar: string }) => <Box {...props} />)(({ theme, opensidebar }) => ({
    width: opensidebar === "true" ? "400px" : "0px",
    display: "flex",
    height: "100vh",
    zIndex: 1000,
    transition: "width 0.3s linear",
    "@media (min-width: 300px) and (max-width: 600px)": {
        width: opensidebar === "true" ? "90%" : "0px",
    },
}));
export const ButtonOpenFilter = styled((props: BoxProps) => <Box {...props} />)(() => ({
    cursor: "pointer",
    marginTop: 10,
    padding: 0,
    alignSelf: "flex-start",
    transition: "all linear",
    "#filter-mobile": {
        display: "none",
    },
    "@media (min-width: 300px) and (max-width: 600px)": {
        marginTop: 10,
        padding: "8px",
        marginLeft: 10,
        borderRadius: 8,
        alignSelf: "flex-start",
        backgroundColor: "#3F66FA",
        display: "block",
        "#filter-mobile": {
            display: "block",
        },
        "#filter-desktop": {
            display: "none",
        },
    },
}));
export const BoxContainer = styled((props: BoxProps & { searchvalue: string; opensidebar: string }) => <Box {...props} />)(
    ({ theme, searchvalue, opensidebar }) => ({
        backgroundColor: !searchvalue || searchvalue.length < 2 ? "#2F2380" : "#1C1359",
        width: opensidebar === "true" ? "100%" : "0px",
        overflow: "auto",
        paddingBottom: "100px",
        height: "100%",
        zIndex: 1000,
        transition: "width 0.3s linear",
        "@media (min-width: 300px) and (max-width: 600px)": {
            paddingBottom: "200px",
        },
    })
);
export const SelectComponent = styled((props: SelectProps) => (
    <Select
        displayEmpty
        disableUnderline
        labelId="simple-select-label"
        variant="standard"
        id="simple-select"
        renderValue={(selected: any) => {
            if (!selected) {
                return (
                    <Typography color={"#fff"} fontWeight={"bold"} fontFamily="IliaMontserrat">
                        Filtrar por área
                    </Typography>
                );
            }
            return (
                <Typography color={"#fff"} fontWeight={"bold"} fontFamily="IliaMontserrat">
                    {selected}
                </Typography>
            );
        }}
        IconComponent={KeyboardArrowDown}
        startAdornment={
            <InputAdornment position="start">
                <JobSearch />
            </InputAdornment>
        }
        MenuProps={{
            PaperProps: {
                style: {
                    borderRadius: 8,
                    marginTop: 15,
                    maxHeight: 300,
                    background: "#E6E7F7",
                },
            },
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "left",
            },
        }}
        {...props}
    />
))(({ theme }) => ({
    width: "100%",
    height: "48px",
    "& .MuiSvgIcon-root": {
        color: "#9192AD",
    },
}));
